"use client";

import React from "react";

export const AppFooter = () => {
    return <div className="layout-footer" />;
};
